import { Result, SlideComponentHkcsEnQ1 } from '@/types/slide';
import { Box, Skeleton } from '@mui/material';
import { ResultContentContainer } from './ResultContentContainer';

import { PhraseHighlight } from '@/components/displays/PhraseHighlight';
import { ResultDisplayEnWriting } from '@/components/results/ResultDisplayEnWriting';
import { useEffect, useState } from 'react';
import { ImageShowcase } from '../../ImageShowcase';
import { PropsWithOnLoad } from '../../type';

export const ResultContentHkcsEnQ1: React.FC<
    PropsWithOnLoad & {
        question: SlideComponentHkcsEnQ1 & { answers: Result[] };
        viewOnly: boolean;
    }
> = ({ question, viewOnly, onLoad }) => {
    const answer = question.answers[0];
    const [loading, setLoading] = useState<boolean | undefined>(answer?.fetchResultFiles ? true : false);
    const [drawing, setDrawing] = useState<string | undefined>(undefined);

    const [loadCount, setLoadCount] = useState<number>((answer?.fetchResultFiles ? 1 : 0) + (question.content.imageURL || question.content.image ? 1 : 0));

    const handleLoadImage = () => {
        setLoadCount((prev) => prev - 1);
    };

    useEffect(() => {
        if (loadCount <= 0) {
            onLoad?.();
        }
    }, [loadCount, onLoad]);

    useEffect(() => {
        if (answer?.fetchResultFiles) {
            setLoading(true);
            answer
                .fetchResultFiles()
                .then((files) => {
                    if (files && files.length > 0) {
                        setDrawing(files[0]?.url);
                    } else {
                        setDrawing(undefined);
                        setLoadCount((prev) => prev - 1);
                    }
                })
                .finally(() => {
                    setLoading(false);
                });
        } else {
            setDrawing(undefined);
        }
    }, [answer]);

    return (
        <ResultContentContainer>
            <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-evenly', gap: 2 }}>
                <Box>
                    <Box
                        sx={{
                            display: 'flex',
                            width: 275,
                            height: 360,
                            flexDirection: 'column',
                            alignItems: 'center',
                            justifyContent: 'space-between',

                            backgroundColor: 'white',
                            borderRadius: '16px',
                            paddingTop: '20px',
                        }}
                    >
                        <ImageShowcase
                            width={211}
                            src={
                                question.content.imageURL && question.content.imageURL !== ''
                                    ? question.content.imageURL
                                    : `/asset/characters/${question.content.image ? question.content.image + '/image.png' : 'default.png'}`
                            }
                            onLoad={handleLoadImage}
                        />
                        <PhraseHighlight sx={{ color: '#555', my: 2 }} phrase={question.content.phrase} highlight={question.content.phrase} underline={false} />
                    </Box>
                </Box>

                <Box sx={{ flex: 1, width: 275, display: 'flex', alignItems: 'center', flexDirection: 'column', gap: 2 }}>
                    <Box sx={{ width: 275, height: 265, display: 'flex', flexDirection: 'column' }}>
                        {drawing ? (
                            <Box
                                sx={{
                                    height: '100%',
                                    width: '100%',
                                    borderRadius: 2,
                                    borderColor: 'divider',
                                    borderWidth: 2,
                                    backgroundColor: 'white',

                                    padding: 0,
                                    margin: 0,
                                }}
                            >
                                <Box
                                    component={'img'}
                                    src={drawing}
                                    onLoad={handleLoadImage}
                                    sx={{
                                        height: '100%',
                                        width: '100%',
                                        aspectRatio: 1,
                                        border: 2,
                                        borderRadius: 2,
                                        borderColor: 'divider',
                                    }}
                                />
                            </Box>
                        ) : loading ? (
                            <Skeleton variant='rounded' sx={{ height: '100%', width: '100%', borderRadius: 2 }} />
                        ) : (
                            <Box
                                sx={{
                                    height: '100%',
                                    width: '100%',
                                    backgroundColor: 'white',
                                    borderRadius: 2,
                                    borderColor: 'divider',
                                    borderWidth: 2,
                                }}
                            />
                        )}
                    </Box>
                    <Box sx={{ position: 'relative', width: '100%', flex: 1, justifyItems: 'center' }}>
                        <Box
                            sx={{
                                width: 275,
                                height: 82,
                                backgroundColor: 'white',
                                borderRadius: 1,
                                border: 2,
                                borderColor: 'divider',
                                justifyContent: 'center',
                                display: 'flex',
                                alignItems: 'center',
                            }}
                        >
                            <ResultDisplayEnWriting question={question} showReference={true} viewOnly={viewOnly} />
                        </Box>
                    </Box>
                </Box>
            </Box>
        </ResultContentContainer>
    );
};
